<cotecna-sidemenu-expandable
  #sideMenu
  [options]="shellService.sideMenuOptions"
  (sidemenuActionClicked)="onSidemenuActionClicked($event)"
  ngClass="sideMenuClass"
>
  <router-outlet></router-outlet>
</cotecna-sidemenu-expandable>
